'use client';

import type { FC } from 'react';

import { MenuRootContext } from './context/menu-root.context';
import { useMenu } from './hooks/use-menu';
import type { MenuRootPropsInterface } from './types/menu-root.types';

/**
 * @since 10.0.0
 */
export const MenuRoot: FC<MenuRootPropsInterface> = (props: MenuRootPropsInterface) => {
  const { children, dividers = false, ...rest } = props;
  const menu = useMenu(rest);
  return <MenuRootContext.Provider value={{ dividers, menu }}>{children}</MenuRootContext.Provider>;
};

MenuRoot.displayName = 'Menu.Root';
